import React, { useState } from 'react'
 
const FonctionState = () => {

  const [counter, setCounter ] =  useState(0) // premiere valeur c'est la valeur initial du state, la seconde permettra d'interagir avec mon state et de la modifier

  const addOne = () =>{
      setCounter(prevCounter => prevCounter +2) //
  }

    return (
        <div className="text-warning">
            <p>Function State: {counter} </p>
            <button onClick={addOne}>State dans Fonction</button>
        </div>
    )
}

export default FonctionState
